import { ReactNode, useEffect, useCallback } from 'react';
import { notification } from 'antd';
import { NotificationConText } from '@/hooks/notification.hook';
import { NotificationType } from '@/types/common';
import { useAppSelector } from '@/redux/hooks';
import { watchMessages } from '@/redux/slices/app.slice';

type NotificationProviderProps = {
  children: ReactNode;
};

export const NotificationProvider = ({
  children
}: NotificationProviderProps) => {
  const [api, contextHolder] = notification.useNotification();
  const messages = useAppSelector(watchMessages);

  const notify = useCallback(
    (type: NotificationType, message: string, description?: string) => {
      api[type]({
        message,
        description,
        duration: 5,
        placement: 'topRight'
      });
    },
    [api]
  );

  useEffect(() => {
    messages.forEach(({ type, message, description }) => {
      notify(type, message, description);
    });
  }, [notify, messages]);

  return (
    <NotificationConText.Provider value={{ notify }}>
      {contextHolder}
      {children}
    </NotificationConText.Provider>
  );
};
